import _ from "lodash";

import { Notificator } from "../../../../components/notification";
import { getPreviewParams } from "../brandingForm/branding.selectors";
import {
  getInvalidValues,
  removeInvalidValues,
} from "../../helpers/form.helper";
import { isFailure, ResourceName } from "@sportal/api";

export const loadSafety =
  () =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
    } = getState();

    const result = await api.ssm.bpResources.getResource(
      id,
      ResourceName.Safety
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("error_failed_to_load_data"));
      dispatch(loadSafetyFailure(result.error));
      return;
    }

    dispatch(loadSafetySuccess(result.data));
  };

export const changeSafety =
  () =>
  async (dispatch, getState, { api }) => {
    const {
      subscriberInfo: { id },
      resources: {
        safety: { resource, validation, toSave },
      },
    } = getState();

    const newSafety = _.mapValues(toSave, (prop) =>
      prop.trim ? prop.trim() : prop
    );

    const updatedSafety = _.defaults(newSafety, resource),
      validatedSafety = removeInvalidValues(updatedSafety, validation),
      valuesToSave = getInvalidValues(newSafety, validation);

    const result = await api.ssm.bpResources.updateResource(
      id,
      ResourceName.Safety,
      validatedSafety
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("couldnt_save_changes"));
      dispatch(changeSafetyFailure(result.error));
      return Promise.reject();
    }

    dispatch(changeSafetySuccess(validatedSafety, valuesToSave));
  };

export const getSafetyPreview =
  () =>
  async (dispatch, getState, { api }) => {
    const state = getState(),
      {
        subscriberInfo: { id },
        resources: { safety },
      } = state;

    const { toSave: newSafety, resource, validation } = safety,
      updatedSafety = _.defaults(newSafety, resource),
      validatedSafety = removeInvalidValues(updatedSafety, validation),
      previewParams = getPreviewParams(validatedSafety)(state);

    const result = await api.ssm.bpResources.getPreview(
      id,
      ResourceName.Safety,
      previewParams
    );

    if (isFailure(result)) {
      dispatch(Notificator.error("error_failed_to_load_data"));
      dispatch(loadSafetyFailure(result.error));
      return Promise.reject();
    }

    localStorage.setItem("sub-safety", result.data);
  };

export const LOAD_SAFETY_SUCCESS = "[RESOURCES] [SAFETY] LOAD_SAFETY_SUCCESS";
export const LOAD_SAFETY_FAILURE = "[RESOURCES] [SAFETY] LOAD_SAFETY_FAILURE";
export const CHANGE_ADMIN_EMAIL_TO_SAVE =
  "[RESOURCES] [SAFETY] CHANGE_ADMIN_EMAIL_TO_SAVE";
export const CHANGE_ADMIN_PHONE_TO_SAVE =
  "[RESOURCES] [SAFETY] CHANGE_ADMIN_PHONE_TO_SAVE";
export const CHANGE_MESSAGE_TO_SAVE =
  "[RESOURCES] [SAFETY] CHANGE_MESSAGE_TO_SAVE";
export const CHANGE_SHOW_MESSAGE_TO_SAVE =
  "[RESOURCES] [SAFETY] CHANGE_SHOW_MESSAGE_TO_SAVE";
export const CHANGE_SAFETY_SUCCESS =
  "[RESOURCES] [SAFETY] CHANGE_SAFETY_SUCCESS";
export const CHANGE_SAFETY_FAILURE =
  "[RESOURCES] [SAFETY] CHANGE_SAFETY_FAILURE";
export const RESET_TO_SAVE = "[RESOURCES] [SAFETY] RESET_TO_SAVE";

export const loadSafetySuccess = (safety) => ({
  type: LOAD_SAFETY_SUCCESS,
  payload: safety,
});
export const loadSafetyFailure = (error) => ({
  type: LOAD_SAFETY_FAILURE,
  payload: error,
});
export const changeAdminEmailToSave = (adminEmail) => ({
  type: CHANGE_ADMIN_EMAIL_TO_SAVE,
  payload: adminEmail,
});
export const changeAdminPhoneToSave = (adminPhone) => ({
  type: CHANGE_ADMIN_PHONE_TO_SAVE,
  payload: adminPhone,
});
export const changeMessageToSave = (message) => ({
  type: CHANGE_MESSAGE_TO_SAVE,
  payload: message,
});
export const changeShowMessageToSave = () => ({
  type: CHANGE_SHOW_MESSAGE_TO_SAVE,
});
export const changeSafetySuccess = (safety, toSave) => ({
  type: CHANGE_SAFETY_SUCCESS,
  payload: { safety, toSave },
});
export const changeSafetyFailure = (error) => ({
  type: CHANGE_SAFETY_FAILURE,
  payload: error,
});
export const resetToSave = () => ({
  type: RESET_TO_SAVE,
});
